var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerusahaan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1429 0H1.85714C1.3646 0 0.892226 0.195663 0.543944 0.543944C0.195663 0.892226 0 1.3646 0 1.85714V17.6429C0 17.8891 0.0978315 18.1253 0.271972 18.2995C0.446113 18.4736 0.682299 18.5714 0.928571 18.5714H12.0714C12.3177 18.5714 12.5539 18.4736 12.728 18.2995C12.9022 18.1253 13 17.8891 13 17.6429V1.85714C13 1.3646 12.8043 0.892226 12.4561 0.543944C12.1078 0.195663 11.6354 0 11.1429 0ZM5.57143 13H2.78571V11.1429H5.57143V13ZM5.57143 9.28571H2.78571V7.42857H5.57143V9.28571ZM5.57143 5.57143H2.78571V3.71429H5.57143V5.57143ZM10.2143 13H7.42857V11.1429H10.2143V13ZM10.2143 9.28571H7.42857V7.42857H10.2143V9.28571ZM10.2143 5.57143H7.42857V3.71429H10.2143V5.57143Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerusahaan);
export default __webpack_public_path__ + "static/media/perusahaan.7be3b55ec7de6c9e76165bcd4550a071.svg";
export { ForwardRef as ReactComponent };